export { IPluginAbi } from "../IPlugin.js";
